// components/InputBar.tsx

import React, { useState, useEffect, useCallback } from 'react';
import { Send, RotateCcw, Mic, Archive } from 'react-feather';
import { useRealtimeService } from '../contexts/RealtimeServiceContext';
import { useFabricService } from '../contexts/FabricServiceContext';
import './InputBar.scss';

interface InputBarProps {

}

export const InputBar: React.FC<InputBarProps> = ({

}) => {
    const [inputText, setInputText] = useState('');
    const { isConnected, canPushToTalk, sendMessage, isRecording, startRecording, stopRecording, items } = useRealtimeService();
    const { isFabric, resumeSession, triggerPresetMessage } = useFabricService();
    const [isNewConversation, setIsNewConversation] = useState(true);
    const [allowResume, setAllowResume] = useState(true);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const message = inputText.trim();
        if (message) {
            sendMessage(message);
            setInputText('');
        }
    };

    const handleAuto = useCallback(async () => {
        triggerPresetMessage()
    }, []);

    const handleResume = useCallback(async () => {
        setIsNewConversation(false);
        resumeSession()
    }, []);

    const handleStartRecording = useCallback(() => {
        if (isConnected && canPushToTalk && !isRecording) {
            startRecording();
        }
    }, [isConnected, canPushToTalk, isRecording, startRecording]);

    const handleStopRecording = useCallback(() => {
        if (isRecording) {
            stopRecording();
        }
    }, [isRecording, stopRecording]);

    const micButtonStyle = isRecording
        ? { backgroundColor: '#3c00ff', color: '#ececf1' }
        : {};

    useEffect(() => {
        const handleMouseUp = () => {
            if (isRecording) {
                handleStopRecording();
            }
        };

        document.addEventListener('mouseup', handleMouseUp);

        return () => {
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isRecording, handleStopRecording]);

    useEffect(() => {
        const canResume = isFabric && isNewConversation && items.length == 0
        if (canResume != allowResume) {
            setAllowResume(canResume);
        }
    }, [isFabric, items, isNewConversation]);

    useEffect(() => {
        if (!isConnected) {
            setIsNewConversation(true);
        }
    }, [isConnected]);

    return (
        <form onSubmit={handleSubmit} data-component="InputBar">
            <input
                type="text"
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                placeholder="Type your message..."
                disabled={!isConnected}
            />
            <button type="submit" title='Submit' disabled={!isConnected} className="send-button">
                <span className="icon"><Send /></span>
            </button>
            {isFabric && <button type="button" onClick={handleAuto} disabled={!isConnected} title="Next Message">
                <span className="icon"><Archive /></span>
            </button>}
            {allowResume && (
                <button type="button" onClick={handleResume} disabled={!isConnected} title="Resume">
                    <span className="icon"><RotateCcw /></span>
                </button>
            )}
            {canPushToTalk && (
                <button
                    type="button"
                    onMouseDown={handleStartRecording}
                    onMouseUp={handleStopRecording}
                    onMouseLeave={handleStopRecording}
                    disabled={!isConnected}
                    style={micButtonStyle}
                    title="Push to Talk"
                >
                    <span className="icon"><Mic /></span>
                </button>
            )}
        </form>
    );
};
